import automationClient from "lib/automation-client";
import { X } from "lucide-react";
import React, { useState } from "react";
import { Button } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import socket from "socket";

function TerminalModal({ automationName, processId, title }) {
  const [show, setShow] = useState(false);
  const [log, setLog] = useState("")
  const handleClose = () => {
    setLog("")
    setShow(false)
  }
  const handleShow = () => setShow(true)
  const getLog = async () => {
    const { data } = await automationClient.getLogActomationName(automationName, processId)
    if (data) {
      setLog(data)
    }
  }
  const fetchTerminaltLog = async () => {
    socket.off(automationName);

    // Add listener
    socket.on(automationName, (data) => {
      setLog(_log => {
        return _log + data.log
      });
    });
  };

  React.useEffect(() => {
    if (show) {
      fetchTerminaltLog();
    }

    return () => {
      socket.off(automationName);
    };
  }, [show]);

  React.useEffect(() => {
    if (show) {
      getLog()
    }
  }, [show])


  return (
    <>
      <button className="btn btn-dark " style={{ padding: '6px', marginInline: "10px" }} onClick={handleShow}>
        {title ? title : 'Terminal'}
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        size="xl"

      >
        <Modal.Header >
          <Modal.Title>Log ProcessId:- {processId} </Modal.Title>
          <Button variant="secondary" onClick={handleClose}>
            <X />
          </Button>
        </Modal.Header>
        <Modal.Body >

          <pre>{log}</pre>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>

        </Modal.Footer>
      </Modal>
    </>
  );
}

export default TerminalModal;
